import RemoteImage from '@atoms/RemoteImage';
import { Text } from 'native-base';
import PropTypes from 'prop-types';
import React from 'react';
import { Pressable, View } from 'react-native';
import styles from './styles';

/**
 *
 * @param {object} selectedAccountDetails
 * @param {array} withdrawlAccounts
 * @param {function} setWithdrawlAccounts
 * @param {function} setShowAccountSelector
 */
function setSelectedAccountOnPress(selectedAccountDetails, setSelectedAccount, setShowAccountSelector) {
  setSelectedAccount(selectedAccountDetails);
  setShowAccountSelector(false);
}

function AccountRow(props) {
  const { index, item, setSelectedAccount, setShowAccountSelector } = props;
  return (
    <Pressable
      sentr-level={`${index}_account`}
      testID={`${index}_account`}
      sentry-label={`${index}_account`}
      style={styles.accountRow}
      onPress={() => setSelectedAccountOnPress(item, setSelectedAccount, setShowAccountSelector)}>
      <View>
        <RemoteImage uri={item.icon} width={15} height={15} />
      </View>
      <Text testID="txtItemDisplayName" variant="md-normal" marginLeft="16px">
        {item.displayName}
      </Text>
    </Pressable>
  );
}

AccountRow.propTypes = {
  index: PropTypes.number,
  item: PropTypes.shape({
    icon: PropTypes.string,
    displayName: PropTypes.string,
  }),
  setSelectedAccount: PropTypes.func,
  setShowAccountSelector: PropTypes.func,
};

AccountRow.defaultProps = {
  index: 0,
  item: {
    icon: '',
    displayName: '',
  },
  setSelectedAccount: () => {},
  setShowAccountSelector: () => {},
};

export default AccountRow;
